// Кириллица → латиница для подписей авторов фото на EN-страницах. У photoAsset одно поле
// sourceAuthor, и в 11 документах оно кириллическое («Саша Алалыкин», «Danil Зakhvatkin»
// с русской «З») — на английских статьях подпись читалась как ошибка (обход 30.09.2026).
const MAP = {
    а: 'a', б: 'b', в: 'v', г: 'g', д: 'd', е: 'e', ё: 'yo', ж: 'zh', з: 'z', и: 'i', й: 'y',
    к: 'k', л: 'l', м: 'm', н: 'n', о: 'o', п: 'p', р: 'r', с: 's', т: 't', у: 'u', ф: 'f',
    х: 'kh', ц: 'ts', ч: 'ch', ш: 'sh', щ: 'shch', ъ: '', ы: 'y', ь: '', э: 'e', ю: 'yu', я: 'ya',
    і: 'i', ї: 'yi', є: 'ye', ґ: 'g',
};

export function transliterateCyrillic(text) {
    if (typeof text !== 'string' || !/[а-яёіїєґ]/i.test(text)) return text;
    return text.replace(/[а-яёіїєґ]/gi, (ch) => {
        const lower = ch.toLowerCase();
        const latin = MAP[lower] ?? ch;
        if (ch === lower || !latin) return latin;
        return latin[0].toUpperCase() + latin.slice(1);
    });
}
